/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup.js";
import { useDispatch } from "react-redux";
import { login } from "../../../user";
import { resetFunctionwithlogin } from "../../../components/ResetFunction";
import axios from "axios";
import { base_url } from "../../../base_urls";
import { useAuth } from "../../../AuthContext";
import { useSelector } from "react-redux";
import api from "../../../api";
// import { login } from "../../../user";

const validationSchema = Yup.object().shape({
  phone: Yup.string()
    // .matches(/^[0-9]{10}$/, "Please enter a valid 10-digit phone number")
    .required("Phone number is required"),
  password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("Password is required"),
});

const Login = () => {
  // const details = localStorage.getItem("loginDetails");
  const details = useSelector((state) => state.user.value);
  // const loginData = JSON.parse(details);
  const { setIsAuthenticated } = useAuth();
  const Applogo = process.env.REACT_APP_HEADER_LOGO_URL;
// console.log(headerLogoUrl,"test")
  const {
    register,
    control,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      phone: localStorage.getItem("phone") || "",
      password: details.password || "",
    },
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [emailError, setEmailError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // const onSubmit = (data) => {
  //   console.log(data, "data")
  //   axios.post(base_url + "/login").then((res) => console.log(res));
  //   const currentUser = loginData?.find((item) => item?.email === data?.email);
  //   if (!currentUser) {
  //     setEmailError(true); // Email is not registered
  //     navigate("/");
  //   } else if (currentUser.password === data?.password) {
  //     setEmailError(false); // Email is registered, and password is correct
  //     const Value = {
  //       email: data?.email,
  //       password: data?.password,
  //     };
  //     dispatch(login(Value));
  //     localStorage.setItem("credencial", JSON.stringify(Value));
  //     navigate("/admin-dashboard");
  //     resetFunctionwithlogin();
  //   } else {
  //     setEmailError(true); // Email is registered, but the password is incorrect
  //     navigate("/");
  //   }
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const response = await api.post("/login", {
        phone: data.phone,
        password: data.password,
      });

      if (response.data?.status === 200) {
        const user = response.data.data;
        // console.log(user);
        localStorage.setItem("credencial", JSON.stringify(user));
        localStorage.setItem("token", user.token);
        localStorage.setItem("phone", data.phone);
        localStorage.setItem("type", user.role);
        localStorage.setItem("modules", JSON.stringify(user.modules || []));
        localStorage.setItem("userId", user.employee_id);
        localStorage.setItem("employee_code", user.employee_code);
        dispatch(login({ phone: data.phone, password: data.password }));
        setIsAuthenticated(true);

        navigate("/role");
        resetFunctionwithlogin();
      } else {
        setError(response.data.message || "An unknown error occurred.");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.message || "An error occurred.");
      } else {
        setError("An error occurred while trying to log in.");
      }
      console.error("Login API error:", error);
    } finally {
      setLoading(false); // Stop loader
    }
  };

  function refreshPage() {
    window.location.reload(false);
  }

  // const onSubmit = () => {
  //   localStorage.setItem("colorschema", "orange");
  //   localStorage.setItem("layout", "vertical");
  //   localStorage.setItem("layoutwidth", "fixed");
  //   localStorage.setItem("layoutpos", "fluid");
  //   localStorage.setItem("topbartheme", "light");
  //   localStorage.setItem("layoutSized", "lg");
  //   localStorage.setItem("layoutStyling", "default");
  //   localStorage.setItem("layoutSidebarStyle", "dark");

  //   navigate("/admin-dashboard");
  // };

  // useEffect(() => {
  //   setValue("email", localStorage.getItem("email"));
  //   setValue("password", localStorage.getItem("password"));
  // }, []);

  const [eye, seteye] = useState(true);

  const onEyeClick = () => {
    seteye(!eye);
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            {/* <Link to="/job-list" className="btn btn-primary apply-btn">
              Apply Job
            </Link> */}
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/admin-dashboard">
                  <img src={Applogo} alt="Katlax" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Login</h3>
                  <p className="account-subtitle">Access to our dashboard</p>
                  {error && <div className="alert alert-danger">{error}</div>}
                  {/* Account Form */}
                  <div>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <div className="input-block mb-4">
                        <label className="col-form-label">Phone Number</label>
                        <Controller
                          name="phone"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.phone ? "error-input" : ""
                              }`}
                              type="text"
                              placeholder="Enter your phone number"
                              defaultValue={localStorage.getItem("phone")}
                              onChange={field.onChange}
                              value={field.value}
                              autoComplete="tel"
                            />
                          )}
                        />
                        <span className="text-danger">
                          {errors.phone?.message}
                        </span>
                      </div>
                      <div className="input-block mb-4">
                        <div className="row">
                          <div className="col">
                            <label className="col-form-label">Password</label>
                          </div>
                          <div className="col-auto">
                            <Link className="text-muted" to="/forgot-password">
                              Forgot password?
                            </Link>
                          </div>
                        </div>
                        <div style={{ position: "relative" }}>
                          <Controller
                            name="password"
                            control={control}
                            render={({ field }) => (
                              <input
                                className={`form-control ${
                                  errors?.password ? "error-input" : ""
                                }`}
                                type={eye ? "password" : "text"}
                                defaultValue={localStorage.getItem("password")}
                                value={field.value}
                                onChange={field.onChange}
                                autoComplete="current-password"
                              />
                            )}
                          />
                          <span
                            style={{
                              position: "absolute",
                              right: "5%",
                              top: "30%",
                            }}
                            onClick={onEyeClick}
                            className={`fa-solid ${
                              eye ? "fa-eye-slash" : "fa-eye"
                            } `}
                          />
                        </div>
                        <span className="text-danger">
                          {" "}
                          {errors.password?.message}{" "}
                        </span>
                      </div>
                      <div className="input-block text-center">
                        <button
                          className="btn btn-primary account-btn"
                          type="submit"
                          disabled={loading}
                        >
                          {loading ? (
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          ) : (
                            "Login"
                          )}
                        </button>
                      </div>
                    </form>
                    {/* <div className="account-footer">
                      <p>
                        Don't have an account yet?{" "}
                        <Link to="/register">Register</Link>
                      </p>
                    </div> */}
                  </div>
                  {/* /Account Form */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
